import { RightOutlined } from '@ant-design/icons';
import { IssueTaskDoc, StoreIssueDoc } from '@gooduncles/gu-app-schema';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { formatNumber } from 'src/utils/common';
import { formatDate } from 'src/utils/date-util';
import { buildIssueQueryParams, calculateIssueTasksAmount } from 'src/utils/issue-task-util';

import classes from './StoreIssueGroup.module.scss';

type StoreIssueGroupProps = {
  orderDate: string;
  storeIssues: StoreIssueDoc[];
  issueTasks: IssueTaskDoc[];
};

const StoreIssueGroup: FC<StoreIssueGroupProps> = ({ orderDate, storeIssues, issueTasks }) => {
  const navigate = useNavigate();
  const date = formatDate(orderDate, 'L월 d일 (EEEEEE)');
  const queryParams = buildIssueQueryParams(storeIssues, issueTasks);
  const storeIssuesTotalAmount = storeIssues
    ? storeIssues.reduce((acc, cur) => acc + ((cur.supplyPrice ?? 0) + (cur.tax ?? 0)) * (cur.volume ?? 1), 0)
    : 0;
  const issueTasksTotalAmount = calculateIssueTasksAmount(issueTasks);
  const issuesTotalAmount = storeIssuesTotalAmount + issueTasksTotalAmount;
  return (
    <div className={classes.storeIssueGroup} onClick={() => navigate(`/issue-detail${queryParams}`)}>
      <div className={classes.issueInfo}>
        <p className={classes.issueDate}>특이사항: {date}</p>
        <p className={classes.issueAmount}>
          {storeIssues.length + issueTasks.length}건{issuesTotalAmount ? ' / ' : ''}
          {issuesTotalAmount ? `${formatNumber(issuesTotalAmount)}원` : ''}
        </p>
      </div>
      <RightOutlined />
    </div>
  );
};

export default StoreIssueGroup;
